import React from "react";
import { Grid } from "@material-ui/core";
import { Controller } from "react-hook-form";
import { EventNotification } from "../../domain/EventNotification";
import { SectionProps } from "./SectionProps";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { fieldLabels } from "./fieldLabels";

export const MarksAffected: React.FC<SectionProps<EventNotification>> = ({
  control,
  errors,
  disabled,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Controller
          control={control}
          name="numMarksAffected"
          as={
            <TextField
              label={fieldLabels.numMarksAffected}
              type="number"
              inputProps={{ min: 0 }}
              readOnly={disabled}
              data-test="marks-affected"
            />
          }
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          control={control}
          name="numMarksTotal"
          as={
            <TextField
              label={fieldLabels.numMarksTotal}
              type="number"
              inputProps={{ min: 0 }}
              readOnly={disabled}
              data-test="total-marks-affected"
            />
          }
        />
      </Grid>
    </Grid>
  );
};
